$(document).ready(function () {

  // Video slider
  if ($('.video-slider').length) {

    $('.video-carousel').slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      infinite: true,
      arrows: true, 
      prevArrow: '<button type="button" class="slick-prev"><svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48" fill="none"><path d="M31 38L17 24L31 10" stroke="white" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
      nextArrow: '<button type="button" class="slick-next"><svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48" fill="none"><path d="M18 38L32 24L18 10" stroke="white" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
      responsive: [
        {
          breakpoint: 768,
          settings: "unslick"
        }
      ]
    });

    // Slider
    $('.video-slider').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      infinite: true,
      arrows: true,
      fade: true
    });
    

    let activeVideo = false;

    // Pause current video & play next on slide change
    $('.video-slider').on('beforeChange', function(event, slick, currentSlide, nextSlide) {
      if(activeVideo) {
        if(!activeVideo.paused) {
          activeVideo.pause();
        }
        
        document.querySelector('#current-video video').setAttribute('src','');
        document.querySelector('#current-video video').innerHTML = '';
        $('#current-video').parent().parent().parent().parent().empty();
         activeVideo = false;
      }

      const selector = '#video-' + (nextSlide + 1);

      const src = $(selector).data('video');
      const poster = $(selector).data('poster');

      const video = '<video controls width="273" height="485" id="current-video" poster="' + poster + '" preload="auto" autoplay playsinline><source src="' + src + '" type="video/mp4"></video>';

      $(selector).html(video);

      activeVideo = new MediaElementPlayer('current-video', {
        stretching: 'responsive',
        alwaysShowControls: true
      });

    });

    // Initialize Mediaelementjs players when lightbox opened
    Fancybox.bind('.video-carousel-block [data-fancybox]', {
      on: {
        reveal: (fancybox, eventName) => {
          $('.video-slider').slick('setPosition');
          const linkId = eventName.triggerEl.id;
          const index = document.getElementById(linkId).getAttribute('data-index');
          const selector = '#video-' + index;
          
          $('.video-slider').slick('setPosition').slick('slickGoTo', index - 1);

          if( !activeVideo) {
            const src = $(selector).data('video');
            const poster = $(selector).data('poster');

            const video = '<video controls width="273" height="485" id="current-video" poster="' + poster + '" preload="metadata" autoplay playsinline><source src="' + src + '" type="video/mp4"></video>';

            $(selector).html(video);

            activeVideo = new MediaElementPlayer('current-video', {
              stretching: 'responsive',
              alwaysShowControls: true
            });
          }

        },
        close: () => {
          if(activeVideo && !activeVideo.paused) {
            activeVideo.pause();
          }

          $('#current-video').parent().parent().parent().parent().empty();
          activeVideo = false;
        }
      },
    } );

    // Close lightbox if slide clicked on (not child elements though)
    $('.video-slider .slick-slide .cols').on('click', function(e) {
      if(e.target == this) {
        Fancybox.close();
      }
    });


    // Scrolling
    let isDown = false;
    let wasDrag = false;
    let startX;
    let scrollLeft;

    // Drag stops
    const end = (slider, e) => {
      isDown = false;
      slider.classList.remove('active');
    }

    // Drag starts
    const start = (slider, e) => {
      isDown = true;
      wasDrag = false;
      slider.classList.add('active');
      startX = e.pageX || e.touches[0].pageX - slider.offsetLeft;
      scrollLeft = slider.scrollLeft;
    }

    // Drag in progress
    const move = (slider, e) => {
      if (!isDown) return;

      e.preventDefault();
      const x = e.pageX || e.touches[0].pageX - slider.offsetLeft;
      const dist = x - startX;
      slider.scrollLeft = scrollLeft - dist;
      if(dist < -1) {
        wasDrag = true;
      } 
    }

    // Select scrollers
    const sliders = document.querySelectorAll('.video-carousel');

    // Attach events
    sliders.forEach(slider => {
      slider.addEventListener('mousedown', (e) => start(slider, e));
      slider.addEventListener('mousemove', (e) => move(slider, e));
      slider.addEventListener('mouseleave', (e) => end(slider, e));
      slider.addEventListener('mouseup', (e) => end(slider, e));
    });

    // If isn't a drag then allow link click
    $('.video-carousel a').on('click', function(e) {
      //console.log('wasDrag', wasDrag);
      if(wasDrag) {
        e.preventDefault();
      } 
    });
  }

});